<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <defs>
      <clipPath id="master_svg0_566_50127">
        <rect x="0" y="0" width="16" height="16" rx="0" />
      </clipPath>
    </defs>
    <g clip-path="url(#master_svg0_566_50127)">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10,12L8,12Q7.90151,12,7.80491,11.9808Q7.70831,11.9616,7.61732,11.9239Q7.52632,11.8862,7.44443,11.8315Q7.36254,11.7767,7.29289,11.7071Q7.22325,11.6375,7.16853,11.5556Q7.11381,11.4737,7.07612,11.3827Q7.03843,11.2917,7.01921,11.1951Q7,11.0985,7,11Q7,10.9015,7.01921,10.8049Q7.03843,10.7083,7.07612,10.6173Q7.11381,10.5263,7.16853,10.4444Q7.22325,10.3625,7.29289,10.2929Q7.36254,10.2232,7.44443,10.1685Q7.52632,10.1138,7.61732,10.0761Q7.70831,10.0384,7.80491,10.0192Q7.90151,10,8,10L13,10Q13.4142,10,13.7071,9.70711Q14,9.41421,14,9L14,7Q14,6.58579,13.7071,6.29289Q13.4142,6,13,6L12,6Q12,7.24264,11.1213,8.12132Q10.2426,9,9,9L7,9Q6.58579,9,6.29289,9.29289Q6,9.58579,6,10L6,13Q6,13.4142,6.29289,13.7071Q6.58579,14,7,14L9,14Q9.41421,14,9.70711,13.7071Q10,13.4142,10,13L10,12ZM12,12L12,13Q12,14.2426,11.1213,15.1213Q10.2426,16,9,16L7,16Q5.75736,16,4.87868,15.1213Q4,14.2426,4,13L4,12L3,12Q1.75736,12,0.87868,11.1213Q0,10.2426,0,9L0,7Q0,5.75736,0.87868,4.87868Q1.75736,4,3,4L4,4L4,3Q4,1.75736,4.87868,0.87868Q5.75736,0,7,0L9,0Q10.2426,0,11.1213,0.87868Q12,1.75736,12,3L12,4L13,4Q14.2426,4,15.1213,4.87868Q16,5.75736,16,7L16,9Q16,10.2426,15.1213,11.1213Q14.2426,12,13,12L12,12ZM6,4L8,4Q8.09849,4,8.19509,4.01921Q8.29169,4.03843,8.38268,4.07612Q8.47368,4.11381,8.55557,4.16853Q8.63746,4.22325,8.70711,4.29289Q8.77675,4.36254,8.83147,4.44443Q8.88619,4.52632,8.92388,4.61732Q8.96157,4.70831,8.98078,4.80491Q9,4.90151,9,5Q9,5.09849,8.98078,5.19509Q8.96157,5.29169,8.92388,5.38268Q8.88619,5.47368,8.83147,5.55557Q8.77675,5.63746,8.70711,5.70711Q8.63746,5.77675,8.55557,5.83147Q8.47368,5.88619,8.38268,5.92388Q8.29169,5.96157,8.19509,5.98078Q8.09849,6,8,6L3,6Q2.58579,6,2.29289,6.29289Q2,6.58579,2,7L2,9Q2,9.41421,2.29289,9.70711Q2.58579,10,3,10L4,10Q4,8.75736,4.87868,7.87868Q5.75736,7,7,7L9,7Q9.41421,7,9.70711,6.70711Q10,6.41421,10,6L10,3Q10,2.58579,9.70711,2.29289Q9.41421,2,9,2L7,2Q6.58579,2,6.29289,2.29289Q6,2.58579,6,3L6,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutPython',
} as DefineComponent
</script>
